import type { TargetStatus } from '../contracts';

const EPSILON = 1e-9;

export interface TargetStatusInput {
  required: number | null;
  current: number | null;
  unreachable?: boolean;
  ambiguous?: boolean;
  unresolved?: boolean;
}

/**
 * SPEC-009 §42/§43/plan §25 — pure status classification. Precedence:
 * ambiguous > unreachable > unknown > met/below/above, matching AC-039–044.
 */
export function computeTargetStatus(input: TargetStatusInput): TargetStatus {
  if (input.ambiguous) return 'ambiguous';
  if (input.unreachable) return 'unreachable';
  if (input.unresolved || input.required === null || input.current === null) return 'unknown';
  if (Math.abs(input.current - input.required) <= EPSILON) return 'met';
  return input.current < input.required ? 'below' : 'above';
}

/** SPEC-009 §41 — gap = required - current, only when both are known. */
export function computeGap(required: number | null, current: number | null): number | null {
  if (required === null || current === null) return null;
  return required - current;
}
